import React, { useEffect, Component } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sendToMake } from '../utils/makeWebhook';
import { getUtmParams } from '../utils/utmTracking';
export function TranzilaSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const handlePaymentSuccess = async () => {
      // Get order details from localStorage
      const pendingOrderStr = localStorage.getItem('pendingOrder');
      const registrationDataStr = localStorage.getItem('pendingRegistrationData');
      if (pendingOrderStr) {
        try {
          const pendingOrder = JSON.parse(pendingOrderStr);
          // Check if order is recent (within last 30 minutes)
          const isRecent = Date.now() - pendingOrder.timestamp < 30 * 60 * 1000;
          if (isRecent) {
            // Send registration data to Make.com webhook
            if (registrationDataStr) {
              try {
                const registrationData = JSON.parse(registrationDataStr);
                // Get UTM parameters - prefer from registration data (more reliable in Meta in-app browsers)
                // Fall back to localStorage if not in registration data
                const utmParams = {
                  utm_source: registrationData.utm_source || getUtmParams().utm_source,
                  utm_medium: registrationData.utm_medium || getUtmParams().utm_medium,
                  utm_campaign: registrationData.utm_campaign || getUtmParams().utm_campaign,
                  utm_content: registrationData.utm_content || getUtmParams().utm_content,
                  utm_term: registrationData.utm_term || getUtmParams().utm_term,
                  utm_id: registrationData.utm_id || getUtmParams().utm_id,
                  fbclid: registrationData.fbclid || getUtmParams().fbclid
                };
                console.log('💳 Payment successful! Sending data to Make.com...');
                console.log('📊 UTM Parameters (from registration data):', utmParams);
                // Track Meta Pixel Purchase event
                if (window.fbq) {
                  window.fbq('track', 'Purchase', {
                    content_name: registrationData.ticketType,
                    content_category: 'Festival Ticket',
                    value: parseFloat(registrationData.price.replace(/,/g, '')),
                    currency: 'ILS',
                    num_items: 1,
                    order_id: registrationData.orderNumber
                  });
                }
                // Check if registration data has a custom webhook URL
                // (e.g. from the additional payment page)
                if (registrationData.webhookUrl) {
                  console.log('📡 Using custom webhook URL:', registrationData.webhookUrl);
                  await fetch(registrationData.webhookUrl, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                      ...registrationData,
                      paid: true,
                      utm_source: utmParams.utm_source,
                      utm_medium: utmParams.utm_medium,
                      utm_campaign: utmParams.utm_campaign,
                      utm_content: utmParams.utm_content,
                      utm_term: utmParams.utm_term,
                      utm_id: utmParams.utm_id,
                      fbclid: utmParams.fbclid
                    })
                  });
                } else {
                  // Default: send to main festival webhook via sendToMake
                  await sendToMake({
                    type: 'הרשמה Water Tribe Fest',
                    name: registrationData.name,
                    email: registrationData.email,
                    phone: registrationData.phone,
                    orderNumber: registrationData.orderNumber,
                    ticketType: registrationData.ticketType,
                    price: registrationData.price,
                    gender: registrationData.gender,
                    companionName: registrationData.companionName,
                    companionPhone: registrationData.companionPhone,
                    companionGender: registrationData.companionGender,
                    nightChoice: registrationData.nightChoice,
                    roomType: registrationData.roomType,
                    roommate1: registrationData.roommate1,
                    roommate2: registrationData.roommate2,
                    competitiveTrack: registrationData.competitiveTrack,
                    rowingType: registrationData.rowingType,
                    clubName: registrationData.clubName,
                    rentBoard: registrationData.rentBoard,
                    whatsappGroup: registrationData.whatsappGroup,
                    source: 'MagicPatterns',
                    paid: true,
                    utm_source: utmParams.utm_source,
                    utm_medium: utmParams.utm_medium,
                    utm_campaign: utmParams.utm_campaign,
                    utm_content: utmParams.utm_content,
                    utm_term: utmParams.utm_term,
                    utm_id: utmParams.utm_id,
                    fbclid: utmParams.fbclid
                  });
                }
                // Clear registration data after successful send
                localStorage.removeItem('pendingRegistrationData');
              } catch (error) {
                console.error('Error sending to Make.com:', error);
                // Continue to thank you page even if webhook fails
              }
            }
            // Clear the pending order
            localStorage.removeItem('pendingOrder');
            // Determine which thank you page to redirect to
            const isAdditionalPayment = registrationDataStr && JSON.parse(registrationDataStr).webhookUrl;
            const thankYouBase = isAdditionalPayment ? '/additional-payment-thank-you' : '/thank-you';
            const thankYouUrl = `${thankYouBase}?orderNumber=${pendingOrder.orderNumber}&name=${encodeURIComponent(pendingOrder.name)}&email=${encodeURIComponent(pendingOrder.email)}`;
            // If we're in an iframe, redirect the parent window
            if (window.top !== window.self) {
              window.top!.location.href = thankYouUrl;
            } else {
              // Otherwise just navigate normally
              navigate(thankYouUrl, {
                replace: true
              });
            }
            return;
          }
        } catch (error) {
          console.error('Error parsing pending order:', error);
        }
      }
      // Fallback: redirect without order number
      const thankYouUrl = '/thank-you';
      if (window.top !== window.self) {
        window.top!.location.href = thankYouUrl;
      } else {
        navigate(thankYouUrl, {
          replace: true
        });
      }
    };
    handlePaymentSuccess();
  }, [navigate, searchParams]);
  return <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    fontFamily: 'sans-serif',
    textAlign: 'center',
    direction: 'rtl'
  }} data-id="element-2175" data-mp="39de7v0y4vmb4">
      <p style={{
      fontSize: '18px',
      color: '#666'
    }} data-id="element-2176" data-mp="30cq4d06d94ch">
        מעבד תשלום… אנא המתן
      </p>
    </div>;
}